<template>
	<v-row align="center" justify="center">
		<v-col cols="12" md="6" class="pr-md-10 d-flex flex-column">
			<v-row class="d-flex order-sm-1">
				<v-col cols="12" class="py-0">
					<h2>{{ language.offer.main_title }}</h2>
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<span class="subtitle-1">{{ language.offer.labels.model }}</span>
						<span class="subtitle-1 font-weight-bold">{{ modelText }}</span>
					</div>
					<div>
						<span class="subtitle-1">{{ language.offer.labels.color }}</span>
						<span class="subtitle-1 font-weight-bold">{{
							selectedColor.name
						}}</span>
					</div>
					<div>
						<span class="subtitle-1">{{
							language.offer.labels.profile_width
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ panel.selectedProfil }} mm</span>
					</div>
					<div class="mb-6">
						<span class="subtitle-1">{{
							language.offer.labels.profile_distance
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ golText }}</span>
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<span class="subtitle-1">{{
							language.offer.labels.total_area
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ suprafata.toFixed(2) }} m²</span>
					</div>
					<div>
						<span class="subtitle-1">{{
							language.offer.labels.panels_area
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ suprafataPanouri }} m²</span>
					</div>
					<div v-if="suprafataPP != 0 || suprafataPPIncluded != 0">
						<span v-if="configuration.poarta_p.buc > 1" class="subtitle-1">{{
							language.offer.labels.person_areas
						}}
						</span>
						<span v-else class="subtitle-1">{{
							language.offer.labels.person_area
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ Number(suprafataPP) + Number(suprafataPPIncluded)
						}}
							m²</span>
					</div>
					<div v-if="configuration.poarta_a.is">
						<span v-if="configuration.poarta_a.buc > 1" class="subtitle-1">{{
							language.offer.labels.car_areas }}
						</span>
						<span v-else class="subtitle-1">{{
							language.offer.labels.car_area
						}}</span>
						<span class="subtitle-1 font-weight-bold">{{ Number(suprafataPA) }} m²</span>
					</div>
				</v-col>
			</v-row>
			<v-row class="order-sm-0">
				<v-col cols="12">
					<v-img ref="finalImg" class="mx-auto flex-shrink-1" max-width="100%"
						:src="require('../assets/img/color/' + imgLink)"></v-img>
				</v-col>
				<v-col cols="12" class="py-0 mb-6">
					<v-alert border="left" colored-border type="info" elevation="1" class="text-body-2">
						{{ language.offer.alerts.concrete_alert1 }}
						{{ language.offer.alerts.concrete_alert2 }}
					</v-alert>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="12" md="6">
			<v-card class="pa-6 elevation-2" color="grey lighten-3" flat
				:class="{ 'scroll-container': !is_mobile_screen }">
				<h2 class="mb-4">{{ language.offer.subtitle }}</h2>
				<div v-if="!completed">
					<v-form ref="ofertaForm" v-model="validForm">
						<p>
							{{ language.offer.underline_text }}
						</p>
						<v-row>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="name" :rules="[rules.required, rules.name]" validate-on-blur
									background-color="white" :label="language.offer.fields_labels.name" validate
									outlined dense v-model="client_data.name"></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="surname" :rules="[rules.required, rules.name]" validate-on-blur
									background-color="white" :label="language.offer.fields_labels.surname" validate
									outlined dense v-model="client_data.surname"></v-text-field>
							</v-col>
						</v-row>

						<v-row>
							<v-col cols=" 12" md="6" class="py-0">
								<v-text-field ref="email" type="email" :rules="[rules.required, rules.email]"
									validate-on-blur background-color="white"
									:label="language.offer.fields_labels.email" validate outlined dense
									v-model="client_data.email"></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="phone" :rules="[rules.phone]" validate-on-blur pattern="\d*"
									background-color="white" :label="language.offer.fields_labels.phone" validate
									outlined dense v-model="client_data.phone"></v-text-field>
							</v-col>
						</v-row>
						<!-- <v-row v-if="country == 'at' || country == 'de'" class="px-3">
							<v-alert border="left" colored-border type="info" dismissible dense width="100%">
								Wir benötigen Ihre E-Mail-Adresse, um Ihnen das Angebot zuzusenden.</v-alert>
						</v-row> -->
						<v-row>
							<v-col class="align-center py-0" cols="12" md="6">
								<p class="mt-2">
									{{ language.offer.fields_labels.choose_county }}
								</p>
							</v-col>
							<v-col class="align-center py-0" cols="12" md="6">
								<v-select ref="county" v-model="client_data.judet" :rules="[rules.required]"
									:items="judete" class="py-0" background-color="white" return-object
									prepend-inner-icon="mdi-magnify" outlined dense></v-select>
							</v-col>
						</v-row>
						<!-- <v-row>
							<v-col class="align-center py-0" cols="12" md="6">
								<p class="mt-2">
									{{ language.offer.fields_labels.choose_timeframe }}
								</p>
							</v-col>
							<v-col class="align-center py-0" cols="12" md="6">
								<v-select ref="timeframe" v-model="client_data.timeframe"
									:items="language.offer.timeframe_items" :rules="[rules.required]" outlined
									background-color="white" :placeholder="language.offer.fields_labels.placeholder_timeframe
						" dense>
								</v-select>
							</v-col>
						</v-row> -->
						<v-row v-if="country == 'ro' && ['Bucuresti', 'Ilfov'].includes(client_data.judet.value)">
							<v-col cols="12" md="12" class="py-2">
								<v-card class="white pa-4 elevation-0">
									<p class="blue--text text--darken-2 font-weight-bold">Doriți ofertă de preț și
										pentru
										stâlpi
										și
										parapet din
										bolțari
										prefabricați?</p>

									<div>
										<v-radio-group v-model="selectedBrikesOffer" :error="bricksAddonError" row
											:rules="[rules.bricks]">
											<v-radio label="DA" :value="true"></v-radio>
											<v-radio label="NU" :value="false"></v-radio>
										</v-radio-group>
									</div>
								</v-card>
							</v-col>
						</v-row>
						<v-textarea v-if="country == 'hu'" name="input-7-1" background-color="white" outlined rows="2"
							dense hide-details label="Megjegyzés" v-model="client_data.message"></v-textarea>
						<v-row>
							<v-col cols="12" class="mt-4 py-0">
								<v-alert v-if="alert.type != 'info'" :value="alert.status" :type="alert.type" dense
									text>{{ alert.text }}
								</v-alert>
							</v-col>
						</v-row>
						<div class="d-flex align-center">
							<v-icon>mdi-information</v-icon>
							<p class="caption mt-4 ml-2">
								<span>
									{{ language.offer.info_text2 }}
								</span>
								<a v-if="country == 'ro'" href="https://garduri-aluminiu.ro/confidentialitate"
									target="_blank">garduri-aluminiu.ro</a>
								<a v-if="country == 'hu'" href="https://i-struct.hu/adatvedelmi"
									target="_blank">i-struct.hu/adatvedelmi</a>
								<a v-if="country == 'de'" href="https://i-struct.de/datenschutz"
									target="_blank">i-struct.de/datenschutz</a>
								<a v-if="country == 'at'" href="https://i-struct.at/datenschutz"
									target="_blank">i-struct.at/datenschutz</a>
								<a v-if="country == 'fr'" href="https://i-struct.fr/politique-de-confidentialite"
									target="_blank">i-struct.fr/politique-de-confidentialite</a>
								<a v-if="country == 'be'" href="https://i-struct.be/politique-de-confidentialite"
									target="_blank">i-struct.be/politique-de-confidentialite</a>
							</p>
						</div>
					</v-form>
				</div>
				<div v-else>
					<v-row>
						<v-col cols="12">
							<v-alert :value="alert.status" :type="alert.type" class="white" outlined dense>{{ alert.text
							}}
							</v-alert>
						</v-col>
					</v-row>
					<div>
						<h3>{{ language.offer.contact_details }}</h3>
						<v-row>
							<v-col>
								<div>
									<span>{{ language.offer.fields_labels.fullname }}:</span>
									<span class="font-weight-bold ml-1">{{ client_data.name }} {{ client_data.surname
									}}</span>
								</div>
								<div>
									<span>{{ language.offer.fields_labels.county }}:</span>
									<span class="font-weight-bold ml-1">{{ client_data.judet.text }}</span>
								</div>
							</v-col>
							<v-col>
								<div>
									<span>{{ language.offer.fields_labels.email }}:</span>
									<span class="font-weight-bold ml-1">{{ client_data.email }}</span>
								</div>
								<div>
									<span>{{ language.offer.fields_labels.phone }}:</span>
									<span class="font-weight-bold ml-1">{{ client_data.phone }}</span>
								</div>
							</v-col>
						</v-row>
					</div>
					<v-row class="mb-4">
						<v-col cols="12" md="12" class="d-flex flex-column flex-md-row justify-space-between py-2"
							style="gap:20px;">
							<v-btn :block="!completedBricksOffer" large color="green white--text"
								class="flex-grow-1 download-btn" @click="downloadOferta">
								<v-icon class="mr-2">mdi-download</v-icon>
								<span>{{ language.offer.buttons.download }}</span>
								<template v-slot:loader>
									<span class="custom-loader">
										<v-icon light>mdi-cached</v-icon>
									</span>
								</template>
							</v-btn>
							<v-btn v-if="completedBricksOffer" color="green white--text" large class="flex-grow-1"
								@click="$emit('downloadBricksOffer')">
								<v-icon class="mr-1" dense>mdi-download</v-icon>
								<span>Descarca oferta boltari</span>
							</v-btn>
						</v-col>
						<v-col cols="12" md="12" class="py-2">
							<v-btn class="email-btn" block large :loading="sendingOferta" :disabled="sendingOferta"
								color="green white--text" @click="sendOferta">
								<v-icon class="mr-2">mdi-email-send</v-icon>
								<span>{{ language.offer.buttons.email }}</span>
								<template v-slot:loader>
									<span class="custom-loader">
										<v-icon light>mdi-cached</v-icon>
									</span>
								</template>
							</v-btn>
							<div v-if="country == 'ro'" class="caption mt-4">
								<v-icon>mdi-information</v-icon>
								<span class="ml-2">{{ language.offer.info_text1 }}</span>
							</div>
						</v-col>

					</v-row>
				</div>
			</v-card>
		</v-col>
		<div v-if="is_mobile_screen || is_tablet_screen" class="mobile-space"></div>
		<!-- <pre>Valid: {{validForm}}</pre> -->
		<!-- <pre>{{ $data }}</pre> -->
		<!-- <pre>Region: {{defaultRegion}}</pre> -->
	</v-row>
</template>

<script>
export default {
	name: "Oferta",
	data: function () {
		return {
			validForm: false,
			validCallbackForm: false,
			selectedBrikesOffer: null,
			bricksAddonError: false,
			callback: false,
			loadingCallback: false,
			client_data: {
				surname: "",
				name: "",
				email: "",
				phone: "",
				judet: "",
				timeframe: "",
				message: "",
				newsletter: false
			},
			rules: {
				required: (value) =>
					!!value || this.language.offer.form_validation.required,
				counter: (value) =>
					value.length <= 20 || this.language.offer.form_validation.max_length,
				name: (value) => {
					const pattern = /^[a-zA-ZáéúőóüíäöüÁÉÚŐÓÜÍÄÖÜß ]+$/;
					return (
						pattern.test(value) || this.language.offer.form_validation.name
					);
				},
				surname: (value) => {
					const pattern = /^[a-zA-ZáéúőóüíäöüÁÉÚŐÓÜÍÄÖÜß ]+$/;
					return (
						pattern.test(value) || this.language.offer.form_validation.name
					);
				},
				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return (
						pattern.test(value) || this.language.offer.form_validation.email
					);
				},
				phone: (value) => {
					const pattern = /\(?([0-9]{2,3})\)?([ .-]?)([0-9]{2,3})\2([0-9]{3,4})/;
					return !value || (
						pattern.test(value) || this.language.offer.form_validation.phone
					);
				},
				judet: (value) => {
					// console.log("J " + value);
					const val = value
						? this.judete.find((judet) => judet.value == value.value)
						: false;
					const isJudet = val ? true : false;
					return isJudet || this.language.offer.form_validation.county;
				},
				bricks: (value) => value != null || this.language.offer.form_validation.required
			},
		};
	},
	props: [
		"language",
		"model",
		"selectedColor",
		"dimensions",
		"configuration",
		"suprafataPanouri",
		"suprafataPP",
		"suprafataPPIncluded",
		"suprafataPA",
		"suprafata",
		"panel",
		"img",
		"country",
		"judete",
		"alert",
		"completed",
		"generatingOferta",
		"sendingOferta",
		"is_mobile_screen",
		"is_tablet_screen",
		"completedBricksOffer",
		"completedCallback"
	],
	watch: {
		validForm(newValue) {
			this.$emit("formValid", newValue);
		},
		validCallbackForm(newValue) {
			this.$emit("formValidCallback", newValue);
		},
		selectedBrikesOffer(newVal, oldVal) {
			if (newVal != oldVal) {
				this.$emit('bricksSelected', newVal)
				this.bricksAddonError = false
			}
		},
		client_data: {
			handler() {
				this.client_data.surname = this.sanitizeName(this.client_data.surname);
				this.client_data.name = this.sanitizeName(this.client_data.name);
				this.client_data.email = this.client_data.email.toLowerCase();
				this.$emit("clientData", this.client_data);
				if (this.selectedBrikesOffer) this.selectedBrikesOffer = null;
			},
			deep: true,
		},
	},
	computed: {
		imgLink() {
			let color = this.selectedColor.name.substring(4);
			let name = this.img.substring(0, this.img.length - 5) + String(color);
			return name + ".png";
		},
		defaultRegion: {
			get: function () {
				let regionName = "Timis";
				if (this.country == "hu") {
					regionName = "Budapest";
				} else if (this.country == "de") {
					regionName = "Berlin";
				} else if (this.country == "at") {
					regionName = "Wien";
				} else if (this.country == "fr") {
					regionName = "Île-de-France";
				} else if (this.country == "be") {
					regionName = "Région de Bruxelles-Capitale";
				}

				let defaultRegion = this.judete.find(
					(region) => region.value == regionName
				);

				return defaultRegion;
			},
			// setter
			set: function (newValue) {
				this.client_data.judet = newValue;
			},
		},
		modelText() {
			let str;
			if (this.model == "horizontal") {
				if (this.country == "ro") {
					str = "orizontal";
				} else if (this.country == "hu") {
					str = "vízszintes";
				} else if (this.country == "de" || this.country == "at") {
					str = "horizontales";
				} else if (this.country == "fr" || this.country == "be") {
					str = "horizontal";
				}
			} else if (this.model == "vertical") {
				if (this.country == "ro") {
					str = "vertical";
				} else if (this.country == "hu") {
					str = "függőleges";
				} else if (this.country == "de" || this.country == "at") {
					str = "horizontales";
				} else if (this.country == "fr" || this.country == "be") {
					str = "vertical";
				}
			}
			return str;
		},
		golText() {
			let str;
			if (this.panel.selectedGapSize == "small") {
				if (this.country == "ro") {
					str = "mica";
				} else if (this.country == "hu") {
					str = "kicsi";
				} else if (this.country == "de" || this.country == "at") {
					str = "kleine";
				} else if (this.country == "fr" || this.country == "be") {
					str = "minimal";
				}
			} else if (this.panel.selectedGapSize == "medium") {
				if (this.country == "ro") {
					str = "medie";
				} else if (this.country == "hu") {
					str = "közepes";
				} else if (this.country == "de" || this.country == "at") {
					str = "mittelere";
				} else if (this.country == "fr" || this.country == "be") {
					str = "moyen";
				}
			} else {
				if (this.country == "ro") {
					str = "mare";
				} else if (this.country == "hu") {
					str = "nagy";
				} else if (this.country == "de" || this.country == "at") {
					str = "große";
				} else if (this.country == "fr" || this.country == "be") {
					str = "large";
				}
			}
			return str;
		},
	},
	methods: {
		sanitizeName(s) {
			if (typeof s !== "string") return "";
			return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
		},
		setFocus(fieldName) {
			this.$refs[fieldName].focus();
		},
		downloadOferta() {
			this.$emit("downloadOferta");
		},
		sendOferta() {
			// console.log("Sending...");
			this.$emit("sendOferta");
		},
	},
	created() {
		if (this.country == "hu") {
			this.client_data.judet = this.defaultRegion;
		}
	},
};
</script>

<style lang="css">
.email-btn .v-btn__content {
	width: 100%;
}

.email-btn .v-btn__content span {
	white-space: normal;
}

.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

.v-input__slot {
	align-items: flex-start !important;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>
